export enum PushFlowErrorCause {
  FailedVacancyStandardsCheck = 'failed-vacancy-standards-check',
}
